import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Subscription } from 'rxjs';
import { ToastService } from '../../../core/state/toast.service';

@Component({
  selector: 'app-msg-popup',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './msg-popup.component.html',
  styleUrls: ['./msg-popup.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MsgPopupComponent implements OnInit, OnDestroy {
  show = false;
  status: 'success' | 'fail' | 'error' | 'info' = 'success';
  msg = '';
  private timer: ReturnType<typeof setTimeout> | null = null;
  private subscription: Subscription | null = null;

  constructor(private toast: ToastService, private cdr: ChangeDetectorRef) {}

  ngOnInit(): void {
    this.subscription = this.toast.messages$.subscribe((data) => {
      if (data) {
        this.show = true;
        this.status = data.status;
        this.msg = data.msg;
        if (this.timer) {
          clearTimeout(this.timer);
        }
        // Mark the component for check right away so the toast appears
        // immediately under OnPush change detection.
        this.cdr.markForCheck();
        this.timer = setTimeout(() => {
          this.show = false;
          this.cdr.markForCheck();
        }, 4000);
      }
    });
  }

  hide(): void {
    this.show = false;
    this.cdr.markForCheck();
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
    if (this.timer) {
      clearTimeout(this.timer);
    }
  }
}
